// shared geometry and state styling for text controls, taken from the DS's Input/controlStyles.ts
// and prefixed with `tw:`

export const CONTROL_BOX = 'tw:rounded-md tw:border tw:border-solid tw:border-gray-300 tw:bg-white tw:shadow-xs';
export const CONTROL_METRICS = 'tw:h-control tw:px-[11px] tw:py-1.75';
export const CONTROL_TEXT = 'tw:text-14 tw:font-normal tw:text-gray-900';

export const CONTROL_STATES = [
  'tw:transition-[border-color,box-shadow] tw:duration-150 tw:ease-in-out',
  'tw:placeholder:text-[rgb(16_24_40/0.3)] tw:placeholder:opacity-100',
  'tw:enabled:hover:border-primary',
  'tw:focus:border-primary tw:focus:outline-none tw:focus:shadow-[0_1px_2px_0_rgb(16_24_40/0.05),0_0_0_4px_rgb(0_122_255/0.1)]',
  'tw:disabled:cursor-not-allowed tw:disabled:bg-light tw:disabled:text-[rgb(16_24_40/0.3)]',
].join(' ');

export const CONTROL_INVALID =
  'tw:border-red-600! tw:enabled:hover:border-red-600 tw:focus:border-red-600 tw:focus:shadow-[0_1px_2px_0_rgb(16_24_40/0.05),0_0_0_4px_rgb(231_0_11/0.1)]';

export const CONTROL_BASE = [
  'tw:block tw:w-full tw:appearance-none',
  CONTROL_BOX,
  CONTROL_METRICS,
  CONTROL_TEXT,
  CONTROL_STATES,
].join(' ');

// split out of GROUP_BASE for wrappers that cannot take CONTROL_METRICS (MultiSelect's trigger
// needs min-h-control)
export const GROUP_STATES = [
  'tw:transition-[border-color,box-shadow] tw:duration-150 tw:ease-in-out',
  'tw:has-enabled:hover:border-primary',
  'tw:focus-within:border-primary tw:focus-within:shadow-[0_1px_2px_0_rgb(16_24_40/0.05),0_0_0_4px_rgb(0_122_255/0.1)]',
].join(' ');
export const GROUP_BASE = [
  'tw:flex tw:w-full tw:items-center tw:gap-2',
  CONTROL_BOX,
  CONTROL_METRICS,
  GROUP_STATES,
].join(' ');
export const GROUP_INVALID =
  'tw:border-red-600! tw:has-enabled:hover:border-red-600 tw:focus-within:border-red-600 tw:focus-within:shadow-[0_1px_2px_0_rgb(16_24_40/0.05),0_0_0_4px_rgb(231_0_11/0.1)]';
export const GROUP_DISABLED = 'tw:cursor-not-allowed tw:bg-light tw:text-[rgb(16_24_40/0.3)]';

export const GROUP_CONTROL = [
  'tw:min-w-0 tw:flex-1 tw:appearance-none tw:border-0 tw:bg-transparent tw:p-0',
  'tw:h-5 tw:w-auto tw:rounded-none tw:shadow-none tw:outline-none',
  CONTROL_TEXT,
  'tw:placeholder:text-[rgb(16_24_40/0.3)] tw:placeholder:opacity-100',
  'tw:focus:outline-none tw:disabled:cursor-not-allowed',
].join(' ');

const AFFIX =
  'tw:flex tw:shrink-0 tw:select-none tw:items-center tw:self-stretch tw:rounded-[5px] tw:bg-lead-input-affix-bg tw:px-2 tw:text-12 tw:font-normal tw:leading-5 tw:text-black';
export const AFFIX_PREFIX = `${AFFIX} tw:-ml-1`;
export const AFFIX_SUFFIX = `${AFFIX} tw:-mr-1`;
